import { HttpParams } from '@angular/common/http';
import { Component } from '@angular/core';
import { settings } from '../shared/globals/settings';
import { AuthService } from '../shared/services/auth.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-external-login',
  templateUrl: './external-login.component.html',
  styleUrls: ['./external-login.component.less']
})
export class ExternalLoginComponent {

	params?: HttpParams;

	constructor(
		private readonly _authService: AuthService,
		private readonly _route: ActivatedRoute
	) {
		if (this._authService.returnUrl) {
			this.params = new HttpParams()
				.set(settings.returnUrlParamName, this._authService.returnUrl);			
		}

		this._route.queryParamMap.subscribe(v => {
			const lang = v.get("lang");
			if (lang) {
				if (!this.params) {
					this.params = new HttpParams();
				}
				this.params = this.params.set("lang", lang);
			}
		});
	}
	
	get loginByGoogleEndpoint(): string {
		if (this.params) {
			return settings.endpoints.loginByGoogle + "?" + this.params.toString();
		}
		else {
			return settings.endpoints.loginByGoogle
		}
	}

	get loginByFacebookEndpoint(): string {
		if (this.params) {
			return settings.endpoints.loginByFacebook + "?" + this.params.toString();
		}
		else {
			return settings.endpoints.loginByFacebook
		}
	}
}
